/** Rollen, die in der Belegung als weiterer Erziehungsberechtigter gelten. */
export const CUSTODIAN_ROLES = ['custodian', 'parent', 'mother', 'father', 'guardian'];

/**
 * Die Person neben dem Zahler. Großeltern und weitere Kontakte bleiben außen vor,
 * und der Zahler selbst steht nicht noch einmal in diesem Reiter.
 */
export function weitererErziehungsberechtigter(guardians, payerId) {
  const links = (guardians || []).filter((rel) => {
    const person = rel?.guardian;
    if (!person || person.is_payer) return false;
    if (payerId && person.id === payerId) return false;
    return CUSTODIAN_ROLES.includes(rel.relationship_type);
  });
  links.sort((a, b) => {
    const rank = (rel) => (
      (rel.relationship_type === 'custodian' ? 0 : 1)
      + (rel.guardian.has_custody ? 0 : 2)
    );
    return rank(a) - rank(b);
  });
  return links[0] || null;
}
